<template>
  <v-container>
    <v-row class="text-center">
      <v-col offset="3" cols="6">
        <v-card class="pa-5">
          <v-card-title>
            {{ $t("views.error.title.error") }}
          </v-card-title>
          <v-card-text>
            <img src="https://www.gstatic.com/youtube/src/web/htdocs/img/monkey.png"/>
            <h2>{{ $t("views.error.content.anErrorOccoured") }}</h2>
            <p>
              {{ $t("views.error.content.errorCode") }}<code>{{ $route.query.errorCode }}</code>
            </p>
            <p>
              <v-btn
                color="success"
                class="mt-4"
                @click="$router.push({path: '/'}).catch(() => {})"
              >
                {{ $t("views.error.content.backToHome") }}
              </v-btn>
            </p>
            <p>
              <v-btn
                color="success"
                class="mt-4"
                @click="$router.push({path: $route.query.targetRoute}).catch(() => {})"
              >
                {{ $t("views.error.content.retry") }}
              </v-btn>
            </p>            
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Error',
  mounted() {

  },
  methods: {

  },
  created() {

  },
  data() {
    return {};
  }
}
</script>
